import Loading from 'components/commons/loading/Loading';
import React from 'react';

export const PortfolioAnalysisLoading = (): React.ReactElement => {
  return (
    <>
      <Loading loading style={{ marginTop: '3rem' }} />
    </>
  );
};
